<nz-spin [nzSpinning]="loading$ | async"
  ><nz-table
    #basicTable
    [nzData]="listOfData"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '1000px', y: 'calc(100vh - 300px)' }">
    <thead>
      <tr>
        <th nzWidth="400px">Name</th>
        <th nzWidth="350px"></th>
        <th nzWidth="100px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data; let i = index">
        <td nzWidth="400px">{{ data.name }}</td>
        <td nzWidth="300px">
          <div class="action-btn-wrapper" *ngIf="data.isEnabled">
            <button
              nz-button
              nzType="default"
              (click)="openEnterDataDrawer(i + 1)">
              Enter Data
            </button>
            <button
              nz-button
              nzType="default"
              (click)="openDataGraphsDrawer(i + 1)">
              Graph
            </button>
            <button
              nz-button
              nzType="default"
              [nzLoading]="data.isPrintLoading"
              (click)="printDatasheet(i + 1, data)">
              Datasheet
            </button>
          </div>
        </td>
        <td nzWidth="100px">
          <button
            nz-button
            nzType="text"
            class="primary-text-btn"
            *ngIf="i > 0"
            (click)="toggleData(data.isEnabled, i + 1)">
            {{ !data.isEnabled ? 'Enable' : 'Remove' }}
          </button>
        </td>
      </tr>
    </tbody></nz-table
  >
  <app-confirm-dialog
    [isVisible]="showConfirmDialog"
    [title]="'Delete Datasheet'"
    message="Are you sure you want to remove this datasheet?"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    [loading]="isDeleting"
    (confirmed)="removeDatasheet()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>
</nz-spin>
